export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "daily_horoscope": "ದೈನಂದಿನ ಜಾತಕವನ್ನು ಅನ್ವೇಷಿಸಿ",
    "daily_cosmic_guidance": "ದೈನಂದಿನ ಕಾಸ್ಮಿಕ್ ಮಾರ್ಗದರ್ಶನ",
    "daily_horoscope_description": "ನಿಮ್ಮ ರಾಶಿ ಚಿಹ್ನೆಗೆ ಅನುಗುಣವಾಗಿ ವೈಯಕ್ತಿಕ ದೈನಂದಿನ ಜಾತಕ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಪಡೆಯಿರಿ. ಪ್ರೇಮ, ವೃತ್ತಿ, ಆರೋಗ್ಯ ಮತ್ತು ಹಣಕಾಸಿನ ಒಳನೋಟಗಳನ್ನು ದೈನಂದಿನ ಅದೃಷ್ಟದ ಸಂಖ್ಯೆಗಳು, ಬಣ್ಣಗಳು ಮತ್ತು ನಿಮ್ಮ ದಿನವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ನ್ಯಾವಿಗೇಟ್ ಮಾಡಲು ಕಾಸ್ಮಿಕ್ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ಸ್ವೀಕರಿಸಿ.",

    // Service Information
    "enter_details_for_horoscope": "ದೈನಂದಿನ ಜಾತಕಕ್ಕಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "daily_horoscope_subscription": "ದೈನಂದಿನ ಜಾತಕ ಚಂದಾದಾರಿಕೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "daily_horoscope_subscription_note": "ವೈಯಕ್ತಿಕ ದೈನಂದಿನ ಜಾತಕ ವಿತರಣೆಗಾಗಿ ಮಾಸಿಕ ಚಂದಾದಾರಿಕೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_cosmic_influence": "ನಿಮ್ಮ ಹೆಸರು ವೈಯಕ್ತಿಕ ಭವಿಷ್ಯವಾಣಿಗಳಿಗಾಗಿ ಕಾಸ್ಮಿಕ್ ಕಂಪನಗಳೊಂದಿಗೆ ಪ್ರತಿಧ್ವನಿಸುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_zodiac_sign": "ನಿಮ್ಮ ರಾಶಿ ಚಿಹ್ನೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ನಿರ್ಧರಿಸಲು ಅತ್ಯಗತ್ಯ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ದೈನಂದಿನ ಜಾತಕವನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Horoscope Features
    "daily_predictions": "ದೈನಂದಿನ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "love_relationship_insights": "ಪ್ರೇಮ ಮತ್ತು ಸಂಬಂಧದ ಒಳನೋಟಗಳು",
    "career_money_guidance": "ವೃತ್ತಿ ಮತ್ತು ಹಣದ ಮಾರ್ಗದರ್ಶನ",
    "health_wellness_tips": "ಆರೋಗ್ಯ ಮತ್ತು ಕಲ್ಯಾಣ ಸಲಹೆಗಳು",
    "lucky_numbers_colors": "ಅದೃಷ್ಟದ ಸಂಖ್ಯೆಗಳು ಮತ್ತು ಬಣ್ಣಗಳು",
    "monthly_horoscope_bonus": "ಮಾಸಿಕ ಜಾತಕ ಬೋನಸ್",

    "what_you_get": "ನಿಮ್ಮ ದೈನಂದಿನ ಜಾತಕದಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "personalized_daily_readings": "ವೈಯಕ್ತಿಕ ದೈನಂದಿನ ವಾಚನಗಳು",
    "love_career_predictions": "ಪ್ರೇಮ ಮತ್ತು ವೃತ್ತಿ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "daily_lucky_elements": "ದೈನಂದಿನ ಅದೃಷ್ಟದ ಅಂಶಗಳು",
    "monthly_bonus_insights": "ಮಾಸಿಕ ಬೋನಸ್ ಒಳನೋಟಗಳು",

    // Actions & Buttons
    "subscribe_to_horoscope": "ದೈನಂದಿನ ಜಾತಕಕ್ಕೆ ಚಂದಾದಾರರಾಗಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ಚಂದಾದಾರಿಕೆ ಸೆಟಪ್ ಮಾಡುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "horoscope_subscription_processing": "ನಿಮ್ಮ ದೈನಂದಿನ ಜಾತಕ ಚಂದಾದಾರಿಕೆ ಈಗ ಸಕ್ರಿಯವಾಗಿದೆ. ವಿಶ್ವಾಸದೊಂದಿಗೆ ನಿಮ್ಮ ದಿನವನ್ನು ಪ್ರಾರಂಭಿಸಲು ಪ್ರತಿ ಬೆಳಿಗ್ಗೆ ವೈಯಕ್ತಿಕ ಕಾಸ್ಮಿಕ್ ಮಾರ್ಗದರ್ಶನವನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "daily_delivery": "ದೈನಂದಿನ ವಿತರಣೆ",
    "daily_horoscope_delivery_note": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜಾತಕ ಪ್ರತಿ ಬೆಳಿಗ್ಗೆ ಬರುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ದೈನಂದಿನ ಜಾತಕವನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ದೈನಂದಿನ ಜಾತಕವನ್ನು ವಿತರಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ದೈನಂದಿನ ಜಾತಕ ಪ್ಯಾಕೇಜ್",
    "daily_horoscope_reading": "ವೈಯಕ್ತಿಕ ದೈನಂದಿನ ಜಾತಕ ವಾಚನ",
    "love_relationship_daily_insights": "ಪ್ರೇಮ ಮತ್ತು ಸಂಬಂಧದ ದೈನಂದಿನ ಒಳನೋಟಗಳು",
    "career_financial_guidance": "ವೃತ್ತಿ ಮತ್ತು ಹಣಕಾಸಿನ ದೈನಂದಿನ ಮಾರ್ಗದರ್ಶನ",
    "health_wellness_daily_tips": "ಆರೋಗ್ಯ ಮತ್ತು ಕಲ್ಯಾಣದ ದೈನಂದಿನ ಸಲಹೆಗಳು",
    "monthly_special_predictions": "ಮಾಸಿಕ ವಿಶೇಷ ಭವಿಷ್ಯವಾಣಿಗಳು",

    // Visual Content
    "sample_daily_horoscope": "ಮಾದರಿ ದೈನಂದಿನ ಜಾತಕ",
    "leo_horoscope_today": "ಇಂದು ಸಿಂಹ ರಾಶಿ ಜಾತಕ",
    "sample_horoscope_reading": "ಇಂದು ವೈಯಕ್ತಿಕ ಬೆಳವಣಿಗೆ ಮತ್ತು ಹಣಕಾಸಿನ ಲಾಭಗಳಿಗೆ ಅವಕಾಶಗಳನ್ನು ತರುತ್ತದೆ",
    "sample_horoscope_preview": "ಕಾಸ್ಮಿಕ್ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ದೈನಂದಿನ ಜಾತಕದ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "zodiac_signs": "ರಾಶಿ ಚಿಹ್ನೆಗಳು",

    // Zodiac Sign Names
    "aries": "ಮೇಷ",
    "taurus": "ವೃಷಭ",
    "gemini": "ಮಿಥುನ",
    "cancer": "ಕರ್ಕ",
    "leo": "ಸಿಂಹ",
    "virgo": "ಕನ್ಯಾ",
    "libra": "ತುಲಾ",
    "scorpio": "ವೃಶ್ಚಿಕ",
    "sagittarius": "ಧನು",
    "capricorn": "ಮಕರ",
    "aquarius": "ಕುಂಭ",
    "pisces": "ಮೀನ",

    // Status & Processing
    "your_horoscope_status": "ನಿಮ್ಮ ಜಾತಕ ಚಂದಾದಾರಿಕೆ ಸ್ಥಿತಿ",
    "processing_your_subscription": "ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತಿದೆ",
    "subscription_processing_message": "ನಿಮ್ಮ ದೈನಂದಿನ ಜಾತಕ ಚಂದಾದಾರಿಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗುತ್ತಿದೆ. ನಾಳೆ ಬೆಳಿಗ್ಗೆಯಿಂದ ವೈಯಕ್ತಿಕ ಕಾಸ್ಮಿಕ್ ಮಾರ್ಗದರ್ಶನವನ್ನು ಸ್ವೀಕರಿಸಲು ಪ್ರಾರಂಭಿಸುತ್ತೀರಿ.",
    "subscription_id": "ಚಂದಾದಾರಿಕೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಸಕ್ರಿಯಗೊಳಿಸುತ್ತಿದೆ",
    "active": "ಸಕ್ರಿಯ",
    "confirmation_email_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "daily_whatsapp_updates": "ದೈನಂದಿನ WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "first_horoscope_tomorrow": "ಮೊದಲ ಜಾತಕ ನಾಳೆ ಬೆಳಿಗ್ಗೆ ವಿತರಿಸಲಾಗುತ್ತದೆ",

    // Support & Contact
    "contact_support": "ಜಾತಕ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "subscription_failed": "ಚಂದಾದಾರಿಕೆ ಸಕ್ರಿಯಗೊಳಿಸುವಿಕೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Daily Horoscope Categories
    "general_forecast": "ಸಾಮಾನ್ಯ ಮುನ್ಸೂಚನೆ",
    "love_romance": "ಪ್ರೇಮ ಮತ್ತು ಪ್ರಣಯ",
    "career_profession": "ವೃತ್ತಿ ಮತ್ತು ವೃತ್ತಿ",
    "health_wellbeing": "ಆರೋಗ್ಯ ಮತ್ತು ಯೋಗಕ್ಷೇಮ",
    "finance_money": "ಹಣಕಾಸು ಮತ್ತು ಹಣ",
    "family_relationships": "ಕುಟುಂಬ ಮತ್ತು ಸಂಬಂಧಗಳು",
    "travel_adventure": "ಪ್ರವಾಸ ಮತ್ತು ಸಾಹಸ",
    "spiritual_growth": "ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆ",

    // Lucky Elements
    "lucky_number": "ಅದೃಷ್ಟದ ಸಂಖ್ಯೆ",
    "lucky_color": "ಅದೃಷ್ಟದ ಬಣ್ಣ",
    "lucky_time": "ಅದೃಷ್ಟದ ಸಮಯ",
    "lucky_direction": "ಅದೃಷ್ಟದ ದಿಕ್ಕು",
    "lucky_gemstone": "ಅದೃಷ್ಟದ ರತ್ನ",
    "avoid_color": "ತಪ್ಪಿಸಬೇಕಾದ ಬಣ್ಣ",
    "avoid_time": "ತಪ್ಪಿಸಬೇಕಾದ ಸಮಯ",

    // Daily Ratings
    "love_rating": "ಪ್ರೇಮ ರೇಟಿಂಗ್",
    "career_rating": "ವೃತ್ತಿ ರೇಟಿಂಗ್",
    "health_rating": "ಆರೋಗ್ಯ ರೇಟಿಂಗ್",
    "finance_rating": "ಹಣಕಾಸು ರೇಟಿಂಗ್",
    "overall_rating": "ಒಟ್ಟಾರೆ ದಿನದ ರೇಟಿಂಗ್",

    // Planetary Influences
    "planetary_influence": "ಗ್ರಹ ಪ್ರಭಾವ",
    "moon_phase": "ಚಂದ್ರನ ಹಂತ",
    "ruling_planet": "ಇಂದು ಆಡುಭಟ್ಟ ಗ್ರಹ",
    "planetary_transit": "ಪ್ರಮುಖ ಗ್ರಹ ಸಂಚಾರ",
    "retrograde_alert": "ವಕ್ರಗತಿ ಎಚ್ಚರಿಕೆ",

    // Relationship Insights
    "single_horoscope": "ಅಗೇ/ಹೊರಚಾಚಿ ಪ್ರೇಮ ಮುನ್ಸೂಚನೆ",
    "relationship_horoscope": "ಸಂಬಂಧ ಮುನ್ಸೂಚನೆ",
    "marriage_horoscope": "ವಿವಾಹ ಮುನ್ಸೂಚನೆ",
    "friendship_forecast": "ಸ್ನೇಹ ಮುನ್ಸೂಚನೆ",
    "family_harmony": "ಕುಟುಂಬ ಸಾಮರಸ್ಯ",

    // Career Guidance
    "job_prospects": "ಉದ್ಯೋಗ ನಿರೀಕ್ಷೆಗಳು",
    "business_forecast": "ವ್ಯಾಪಾರ ಮುನ್ಸೂಚನೆ",
    "investment_advice": "ಹೂಡಿಕೆ ಸಲಹೆ",
    "career_decisions": "ವೃತ್ತಿ ನಿರ್ಧಾರಗಳು",
    "workplace_relationships": "ಕೆಲಸದ ಸ್ಥಳದ ಸಂಬಂಧಗಳು",

    // Health Tips
    "physical_health": "ದೈಹಿಕ ಆರೋಗ್ಯ",
    "mental_wellbeing": "ಮಾನಸಿಕ ಯೋಗಕ್ಷೇಮ",
    "exercise_recommendation": "ವ್ಯಾಯಾಮ ಶಿಫಾರಸು",
    "diet_suggestion": "ಆಹಾರ ಸಲಹೆ",
    "stress_management": "ಒತ್ತಡ ನಿರ್ವಹಣೆ",

    // Weekly & Monthly
    "weekly_overview": "ಸಾಪ್ತಾಹಿಕ ವಿಮರ್ಶೆ",
    "monthly_highlights": "ಮಾಸಿಕ ಮುಖ್ಯ ಅಂಶಗಳು",
    "seasonal_forecast": "ಋತುಮಾನದ ಮುನ್ಸೂಚನೆ",
    "year_ahead": "ಮುಂದಿನ ವರ್ಷದ ಪೂರ್ವವೀಕ್ಷಣೆ",

    // Compatibility
    "compatible_signs_today": "ಇಂದು ಹೊಂದಾಣಿಕೆಯ ರಾಶಿಗಳು",
    "challenging_signs": "ಸವಾಲಿನ ರಾಶಿಗಳು",
    "best_match_today": "ಇಂದು ಅತ್ಯುತ್ತಮ ಮ್ಯಾಚ್",
    "avoid_conflicts_with": "ಸಂಘರ್ಷಗಳನ್ನು ತಪ್ಪಿಸಿ",

    // Remedies & Tips
    "daily_remedy": "ದೈನಂದಿನ ಪರಿಹಾರ",
    "positive_affirmation": "ಸಕಾರಾತ್ಮಕ ದೃಢೀಕರಣ",
    "meditation_tip": "ಧ್ಯಾನ ಸಲಹೆ",
    "crystal_recommendation": "ಸ್ಫಟಿಕ ಶಿಫಾರಸು",
    "mantra_for_today": "ಇಂದಿನ ಮಂತ್ರ",

    // Special Occasions
    "birthday_special": "ಜನ್ಮದಿನ ವಿಶೇಷ ಮುನ್ಸೂಚನೆ",
    "new_moon_influence": "ಅಮಾವಾಸ್ಯೆ ಪ್ರಭಾವ",
    "full_moon_impact": "ಹುಣ್ಣಿಮೆ ಪರಿಣಾಮ",
    "eclipse_effects": "ಗ್ರಹಣ ಪರಿಣಾಮಗಳು",
    "festival_predictions": "ಹಬ್ಬದ ಭವಿಷ್ಯವಾಣಿಗಳು",

    // Subscription Management
    "subscription_active": "ಚಂದಾದಾರಿಕೆ ಸಕ್ರಿಯ",
    "next_billing": "ಮುಂದಿನ ಬಿಲ್ಲಿಂಗ್ ದಿನಾಂಕ",
    "cancel_subscription": "ಚಂದಾದಾರಿಕೆ ರದ್ದುಮಾಡಿ",
    "modify_subscription": "ಚಂದಾದಾರಿಕೆ ಮಾರ್ಪಡಿಸಿ",
    "subscription_history": "ಚಂದಾದಾರಿಕೆ ಇತಿಹಾಸ",

    // Personalization
    "customize_preferences": "ಆದ್ಯತೆಗಳನ್ನು ಕಸ್ಟಮೈಸ್ ಮಾಡಿ",
    "delivery_time": "ಆದ್ಯತೆಯ ವಿತರಣಾ ಸಮಯ",
    "content_focus": "ವಿಷಯ ಗಮನ ಕ್ಷೇತ್ರಗಳು",
    "notification_settings": "ಅಧಿಸೂಚನೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",

    // Premium Features
    "premium_insights": "ಪ್ರೀಮಿಯಂ ಒಳನೋಟಗಳು",
    "detailed_analysis": "ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆ",
    "astrologer_notes": "ಜ್ಯೋತಿಷಿಯ ವೈಯಕ್ತಿಕ ಟಿಪ್ಪಣಿಗಳು",
    "priority_support": "ಆದ್ಯತೆಯ ಗ್ರಾಹಕ ಬೆಂಬಲ"
};
